import { BaseRequest } from "../../../../base/request/BaseRequest";

/** Request de inicio de sesión por email y password. Constructor privado: se
 *  crea vacío con `createEmptyRequest()` y los campos los llena el formulario. */
export type LoginByEmailPasswordRequest = BaseRequest & {
  /** Email del usuario. */
  email: string;

  /** Password del usuario. */
  password: string;
};

export const fx_createLoginByEmailPasswordRequest =
  (): LoginByEmailPasswordRequest => {
    return {
      email: "",
      password: "",
    };
  };
